document.addEventListener('DOMContentLoaded', function() {
  // PROタグの色を変更する機能
  function changeProTagColor() {
    var tags = document.querySelectorAll('.p-codebuy__typeB_tag, .p-codebuy__staff_single_tag');
    
    tags.forEach(function(tag) {
      if (tag.textContent.trim() === 'PRO' && !tag.classList.contains('is-colored')) {
        // 色の指定（ここでお好みの色に変更できます）
        tag.style.backgroundColor = '#ccac4d';
        tag.style.color = '#FFFFFF';
        
        // 処理済みマークをつける（負荷軽減）
        tag.classList.add('is-colored'); 
      }
    });
  }

  // 初回実行
  changeProTagColor();

  // ページの変化を監視して待ち構える（MutationObserver）
  var observer = new MutationObserver(function() {
    changeProTagColor();
  });

  // bodyタグ全体の監視を開始
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});